import { createFileRoute, redirect } from "@tanstack/react-router";
import { AccountTemplates } from "@/features/consent-solutions/features/pop-up-templates/components/consent-popup-list/components/account-templates";
import { checkUserPermissions } from "@/features/auth";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/popup/account-templates/")({
  beforeLoad: async ({ context, params }) => {
    const { userDetails } = context as AuthorizedRouteContext;
    const { csId } = params;

    const isUserPermitted = checkUserPermissions(userDetails, ["POPUP_TEMPLATE_LIST"], csId);

    if (!isUserPermitted) {
      redirect({
        to: "/consent-solutions",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => <AccountTemplates />,
});

export { Route };
